import { Metamodel } from '../base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { OdbcLinkedService } from './odbc.linkedservice';
@Metamodel.model({
    name: adfModelTypeMap.informix.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Informix_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Informix_DisplayText)
    ]
})
export class InformixLinkedService extends OdbcLinkedService {

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
